export default "__VITE_ASSET__fd871060__"